import React, { useEffect } from 'react';

const OkAccedo = () => {
  // <ok-accedo data-key="VAB201" zoom-tipe="0" color="#00590f" ok-accedo>
  // <script value="nosniff" content="application/javascript; charset=UTF-8; X-Content-Type-Options=nosniff" src="//widget.okaccedo.com/last_version/it/okaccedo.js" charset="utf-8"></script>
  useEffect(() => {
    const data = {
      'data-key': 'VER205',
      color: '#00408f',
      'zoom-type': '0',
    };
    const url = '//widget.okaccedo.com/last_version/it/okaccedo.js';

    const tag = document.createElement('ok-accedo');
    tag.setAttribute('ok-accedo', '');

    Object.keys(data).map(function (key) {
      tag.setAttribute(key, data[key]);
    });

    const script = document.createElement('script');
    script.setAttribute('value', 'nosniff');
    script.setAttribute(
      'content',
      'application/javascript; charset=UTF-8; X-Content-Type-Options=nosniff',
    );

    script.setAttribute('charset', 'UTF-8');
    script.setAttribute('src', url);

    setTimeout(function () {
      document.body.appendChild(tag);
      document.getElementsByTagName('body')[0].appendChild(script);
    }, 1000);

    return () => {
      document.body.removeChild(script);
      document.body.removeChild(tag);
    };
  }, []);
  return <></>;
};
export default OkAccedo;
